import axios from 'axios';
import { API_URL } from '../shared/environments';
import * as storage from './storage';

const publicRoutes = [
  '/user/authenticate_user',
  '/user/register_user',
  '/user/new_password',
  '/company/retrieve_company',
  '/company/list_services',
  '/schedule/list_schedule_by_service',
  '/appointment/register_appointment',
  '/appointment/delete_appointment/',
  '/appointment/retrieve_appointment/',
];

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(async config => {
  const newConfigs = config;

  const token = storage.getToken();

  if (
    newConfigs.url &&
    !publicRoutes.some(route => newConfigs.url?.includes(route))
  ) {
    newConfigs.headers.Authorization = `Token ${token}`;
  }

  return newConfigs;
});

export default api;
